import React, { useState, useEffect } from "react";
import parse from 'html-react-parser';
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Banner } from '../../template/Banner';

function Home() {
  const [data, setData] = useState("<div></div>");
  let history = useHistory();

  useEffect(() => {
    function fetchPageData() {
        fetch("http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/temp/statictext/1")
        .then(res => res.json())
        .then(result => setData(result.text))
        .catch(console.log);
    }
    fetchPageData();
  }, []);

  const [searchTerm, setSearchTerm] = useState();
  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  }

  const [targetWorks, setTargetWorks] = useState(true);
  const handleTargetWorksChange = (event) => {
    setTargetWorks(event.target.checked);
    if (!event.target.checked) {
      setTargetAll(false);
    }
  }

  const [targetPeople, setTargetPeople] = useState(true);
  const handleTargetPeopleChange = (event) => {
    setTargetPeople(event.target.checked);
    if (!event.target.checked) {
      setTargetAll(false);
    }
  }

  const [targetPlaces, setTargetPlaces] = useState(true);
  const handleTargetPlacesChange = (event) => {
    setTargetPlaces(event.target.checked);
    if (!event.target.checked) {
      setTargetAll(false);
    }
  }

  const [targetAll, setTargetAll] = useState(true);
  const handleTargetAllChange = (event) => {
    setTargetWorks(event.target.checked);
    setTargetPeople(event.target.checked);
    setTargetPlaces(event.target.checked);
    setTargetAll(event.target.checked);
  }

  const handleSearch = e => {
    history.push({
      pathname: '/search', 
      state: 
      { 
        term: searchTerm,
        tWorks: targetWorks,
        tPeople: targetPeople,
        tPlaces: targetPlaces,
      }
    });
  }

  return (
    <div className="home">

      <Banner />
      
      <div className="container">

        <div className="row">
          <div className="col-lg-12 my-5">
            {parse(data)}
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3 text-center">
            &nbsp;
          </div>
          <div className="col-lg-6 text-center">
            <div className="homepage-search-box-tab">
              <button className="tablinks"><img src="search.png" alt="" />Simple search</button>
              <button className="tablinks inactive" onClick={() => { history.push('/search/advanced') }}><img src="advanced.png" alt="" />Advanced search</button>
            </div>
            <div className="homepage-search-box">
              <div className="search-line">
                <form onSubmit={handleSearch}>
                  <input type="text" className="form-control" aria-describedby="term" placeholder="search term" value={searchTerm} onChange={handleChange} />
                  <Button type="submit" className="btn btn-default active">
                    <img src="search.png" alt="" />
                  </Button>
                </form>
              </div>
              <input type="checkbox" checked={targetWorks} onChange={handleTargetWorksChange} />
              Works
              <input type="checkbox" checked={targetPeople} onChange={handleTargetPeopleChange} />
              People
              <input type="checkbox" checked={targetPlaces} onChange={handleTargetPlacesChange} />
              Places
              <input type="checkbox" checked={targetAll} onChange={handleTargetAllChange} />
              All
            </div>
          </div>
          <div className="col-lg-3 text-center">
            &nbsp;
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3 text-center">
            &nbsp;
          </div>
          <div className="col-lg-6 text-center">
            <div className="homepage-registers-box">
              <h3>View Registers</h3>
              <div className="homepage-registers-box-container">
                <div>
                  <a href="#works">
                    <img src="register-works.png" alt="Works" />
                  </a>
                  <a href="#works">
                    Works
                  </a>
                </div>
                <div>
                  <a href="#places">
                    <img src="register-location.png" alt="Places" />
                  </a>
                  <a href="#places">
                    Places
                  </a>
                </div>
                <div>
                  <a href="#persons">
                    <img src="register-people.png" alt="People" />
                  </a>
                  <a href="#persons">
                    People
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 text-center">
            &nbsp;
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 text-center">
            <a href="https://www.aka.fi/" target="_blank" rel="noreferrer">
              <img
                src="AKA_LA12_pysty__EN_B3___RGB.jpg"
                alt="Academy of Finland logo"
                style={{
                  width: 150
                }}/>
            </a>
            <a href="https://erc.europa.eu/" target="_blank" rel="noreferrer">
              <img
                src="LOGO_ERC-FLAG_EU_.jpg"
                alt="EU flag"
                style={{
                  width: 250
                }}/>
            </a>
            <a href="https://www.helsinki.fi" target="_blank" rel="noreferrer">
              <img
                src="LogoHelsinki.jpg"
                alt="UH logo"
                style={{
                  width: 122
                }}/>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;